import React, { useState } from 'react';
import CharityStackLogo from '../assets/CharityStack Text.png';

function RequestAccess() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setStatus('error');
      setMessage('Please enter your email address');
      return;
    }

    setStatus('loading');
    setMessage('');

    try {
      const EMAIL_CONFIG_URL = import.meta.env.VITE_APP_EMAIL_CONFIG_URL;

      if (!EMAIL_CONFIG_URL) {
        throw new Error('Email backend URL not configured');
      }

      // Extract base URL (remove /email-config endpoint)
      const baseUrl = EMAIL_CONFIG_URL.replace('/email-config', '');
      const response = await fetch(`${baseUrl}/send-password-reset`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const result = await response.json();

      if (response.ok) {
        setStatus('success');
        setMessage('Password reset email sent! Please check your inbox and spam folder.');
        setEmail('');
      } else {
        setStatus('error');
        if (response.status === 404) {
          setMessage('Email address not found. Please contact support if you need access.');
        } else {
          setMessage(result.message || result.error || 'Failed to send password reset email');
        }
      }
    } catch (error) {
      console.error('Error requesting password reset:', error);
      setStatus('error');
      setMessage('An error occurred. Please try again or contact support.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper-light">
      <div className="max-w-md w-full space-y-8 p-8 bg-paper-light rounded-lg shadow">
        <div>
          <img
            src={CharityStackLogo}
            alt="CharityStack Logo"
            className="mx-auto h-12 w-auto"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-ink">
            Request Access
          </h2>
          <p className="mt-2 text-center text-sm text-ink-secondary">
            Having trouble signing in? Enter your email to receive a password reset link.
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="email" className="sr-only">
              Email address
            </label>
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="appearance-none rounded-md relative block w-full px-3 py-2 border border-edge placeholder-ink-muted text-ink focus:outline-none focus:ring-[#2B6777] focus:border-[#2B6777] focus:z-10 sm:text-sm"
              placeholder="Email address"
              disabled={status === 'loading'}
            />
          </div>

          {message && (
            <div
              className={`rounded-md p-4 ${
                status === 'success'
                  ? 'bg-[#EDF3ED] text-green-800'
                  : 'bg-[#F5EDEB] text-red-800'
              }`}
            >
              <p className="text-sm">{message}</p>
            </div>
          )}

          <div>
            <button
              type="submit"
              disabled={status === 'loading'}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-[#2B6777] hover:bg-[#255d6c] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2B6777] disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {status === 'loading' ? 'Sending...' : 'Send Password Reset Email'}
            </button>
          </div>

          <div className="text-center">
            <a
              href={window.location.origin}
              className="text-sm text-[#2B6777] hover:text-[#255d6c]"
            >
              Back to Sign In
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RequestAccess;
